import { useEffect, useRef } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'

function RecenterMap ({ coords, isActive = true }) {
  const map = useMap()
  const lastFittedCoords = useRef(null)

  useEffect(() => {
    if (!isActive) return

    const frameId = requestAnimationFrame(() => {
      map.invalidateSize({
        animate: false,
        pan: true
      })

      if (!coords?.length) {
        lastFittedCoords.current = null
        return
      }

      if (lastFittedCoords.current === coords) return

      const bounds = L.latLngBounds(coords.map(({ lat, lng }) => [lat, lng]))

      map.fitBounds(bounds, {
        padding: [24, 24],
        maxZoom: 16,
        animate: false
      })

      lastFittedCoords.current = coords
    })

    return () => {
      cancelAnimationFrame(frameId)
    }
    // if (coords) {
    // map.setView(coords, 13);
    // }
  }, [coords, isActive, map])

  return null
}

export default RecenterMap
